import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { SetupConditions } from "@/lib/setup-progress";

// A Boo's setup conditions, polled while it's being set up. Polling stops
// once the answer says there's nothing to follow: no conditions (a Boo on
// Railway, whose status costs a Railway call) or no longer creating.
export function useSetupConditions(containerId: string | null | undefined, settingUp: boolean): SetupConditions | undefined {
  const query = useQuery({
    queryKey: ["deployment-status", containerId],
    queryFn: () => api.containers.deploymentStatus(containerId!),
    enabled: !!containerId && settingUp,
    refetchInterval: (q) => {
      const answer = q.state.data;
      if (!settingUp) return false;
      if (answer && (!answer.conditions || answer.status !== "creating")) return false;
      return 3000;
    },
  });
  return query.data?.conditions;
}
